import axios from 'axios';

const api = axios.create({
  baseURL: `${import.meta.env.VITE_API_BASE_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

/**
 * Get proxied PDF URL to avoid CORS issues
 * @param documentId - The document ID
 * @returns Proxied URL through backend
 */
export const getProxiedPdfUrl = (documentId: string): string => {
  const baseURL = api.defaults.baseURL || 'http://localhost:5002/api';
  const token = localStorage.getItem('token');
  return `${baseURL}/documents/proxy/${documentId}?token=${token}`;
};

export default api;
